import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { accountType } from "../../store/accountType/actions";
export var useAccountTypeGetAll = function (trigger, clientId) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var _c = useState(100), limit = _c[0], setLimit = _c[1];
    var dispatch = useDispatch();
    var _d = useSelector(function (state) {
        var _a;
        return ({
            responseAccountType: (_a = state.AccountType.responseAccountType) === null || _a === void 0 ? void 0 : _a.data,
            errorAccountType: state.AccountType.errorAccountType,
            loadingAccountType: state.AccountType.loadingAccountType,
        });
    }), responseAccountType = _d.responseAccountType, errorAccountType = _d.errorAccountType, loadingAccountType = _d.loadingAccountType;
    useEffect(function () {
        if (trigger) {
            dispatch(accountType({
                enable: enable,
                page: page,
                limit: limit,
                clientId: clientId,
                //  projectId: projectId,
                // catalogAccountTypeId,
            }));
        }
    }, [trigger, clientId]);
    return {
        responseAccountType: responseAccountType,
        errorAccountType: errorAccountType,
        loadingAccountType: loadingAccountType,
        setEnable: setEnable,
        setPage: setPage,
        setLimit: setLimit,
    };
};
